<template>
    <div class="module">
        <h1 class="title--m mb-4">1 ESTADO DE LA ORDEN</h1>
        <v-alert class="mt-3" type="warning" color="#9be51a" outlined>
            La orden {{this.$bus.pConsulta.buscadorOrden}} se encuentra en el estado {{this.$bus.pConsulta.datosOrden.DATOSORDEN.STATUS}}
        </v-alert>
        <v-simple-table class="operation-table col-6 mt-2">
            <thead>
                <tr>
                    <th class="text-left title--xs">Fecha</th>
                    <th class="text-left title--xs">Estado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="estado in estados" :key="estado.ESTADO">
                    <td>{{ estado.FECHA }}</td>
                    <td>{{ estado.ESTADO }}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            estados: [],
        }),
        methods: {
            getEstados() {
                let orden = {
                    idOrden: this.$bus.pConsulta.datosOrden.DATOSORDEN.IDORDEN,
                }
                this.$API.getOrdenEstados(orden)
                    .then(response => {
                        this.estados = response.estados
                    })
            }
        },
        created: function () {
            this.getEstados()
        },
    }
</script>

<style scoped>
    .v-alert__content {
        font-size: 18px;
    }

    .v-data-table table th, .operation-table table th {
        font-size: 22px;
    }

    .v-data-table table td, .operation-table table td {
        font-size: 18px;
        text-align: center;
        padding: 2%;
    }
</style>